import { init } from './reducers'

const getPage = url => state => state?.pagination?.[url] ?? init

export default getPage
